module.exports = __webpack_public_path__ + "media/images/gallery/snr_tab_on-e782267d93c628d88e32f05de5daf5b5.jpg";